jQuery(function($){
	  'use strict';
	
	  var BuildShareLinks = (function() {
	
		var buildShareLinks = {};
	
		const FACEBOOK_APP_ID = "1597607463868989";
	
		var getCurrentUrl = function(with_params) {
		  if(with_params) {
			return window.location.href;
		  }
		  return document.location.protocol + "//" + document.location.hostname + document.location.pathname;
		}
	
		const currentUrl = getCurrentUrl(false);
	
		buildShareLinks.linkedin = function(title, summary){
		  var shareUrl = "https://www.linkedin.com/shareArticle?mini=true";
		  if(!!title.trim()){
			shareUrl += "&title=" + encodeURIComponent(title);
		  }
		  if(!!summary.trim()){
			shareUrl += "&summary=" + encodeURIComponent(summary);
		  }
		  shareUrl += "&url=" + encodeURIComponent(currentUrl);
		  return shareUrl;
		}
	
		buildShareLinks.facebook = function(image, title, summary){
		  var shareUrl = "http://www.facebook.com/sharer.php";
		  shareUrl += "?u=" + encodeURIComponent(currentUrl);
		  if(title.trim()){
		    shareUrl += "&title=" + encodeURIComponent(title);
		  }
		  
		  return shareUrl;
		}
	
		buildShareLinks.twitter = function(text){
		  var shareUrl = "https://x.com/share?";
		  if(text.trim()){
			shareUrl += "&text=" + encodeURIComponent(text);
		  }
		  shareUrl += "&url=" + encodeURIComponent(currentUrl);
		  return shareUrl;
		}
	
		buildShareLinks.email = function(subject, body){
		  var shareUrl = "mailto:?";
		  var params = [];
		  if(subject.trim()){
			params.push("subject=" + encodeURIComponent(subject));
		  }
		  if(body.trim()){
			params.push("body=" + encodeURIComponent(body) + '%0D%0A%20%0D%0A' + currentUrl);
		  }
		  return shareUrl + params.join('&');
		}
	
	
		return buildShareLinks;
	  })();
	
	  var getShareImage = function(path) {
		return path ? window.location.hostname + '/' + path : "";
	  }
	
	  var getShareText = function(text) {
		var shareText = '';
		if(text && text.trim()) {
		  shareText = text;
		}
	
		return shareText.trim();
	  }
	
	  var getShareTitle = function(title) {
		var shareTitle = '';
		if(title && title.trim()) {
		  shareTitle = title;
		}
	
		return shareTitle.trim();
	  }
	
	  jQuery('.js-post-share-linkedin').each(function(){
		var summary = getShareText($(this).data().summary);
		var title = getShareTitle($(this).data().title);
		var shareLink = BuildShareLinks.linkedin(title, summary);
	
		jQuery(this).attr('href', shareLink)
	  });
	
	  jQuery('.js-post-share-facebook').each(function(){
		var image = getShareImage($(this).data().picture);
		var summary = getShareText($(this).data().summary);
		var title = getShareTitle($(this).data().title);
		var shareLink = BuildShareLinks.facebook(image, title, summary);
	
		jQuery(this).attr('href', shareLink)
	  });
	
	  jQuery('.js-post-share-twitter').each(function(){
		var text = getShareText($(this).data().title);
		var shareLink = BuildShareLinks.twitter(text);
	
		jQuery(this).attr('href', shareLink)
	  });
	
	  jQuery('.js-post-share-email').each(function(){
		var image = getShareImage($(this).data().picture);
		var title = getShareText($(this).data().title);
		var summary = getShareText($(this).data().summary);
	
		var shareLink = BuildShareLinks.email(title, summary);
	
		jQuery(this).attr('href', shareLink)
	  });
	});
	